import { AxiosResponse } from "axios";

import api from "@/api";

export const getCloneList = (): Promise<AxiosResponse> => api.get("/clones");
